import { CollectionHandlers, CollectionValues } from '../types';

export interface PromoteShowInFeedDrawerProps {
    onClose: VoidFunction;
    step: Step;

    values: {
        suggests: CollectionValues['suggests'];
        currentSuggest: CollectionValues['currentSuggest'];
        suggestsLoading: CollectionValues['suggestsLoading'];
    };
    handlers: {
        onChooseSuggest: CollectionHandlers['onChooseSuggest'];
        onChooseNameClick: VoidFunction;
        onSubmit: VoidFunction;
    };
}

export enum Step {
    CONFIRM = 'CONFIRM',
    CHOOSE_NAME = 'CHOOSE_NAME',
}
